import { render, staticRenderFns } from "./msgCollect.vue?vue&type=template&id=3244b54c&scoped=true"
import script from "./msgCollect.vue?vue&type=script&lang=js"
export * from "./msgCollect.vue?vue&type=script&lang=js"
import style0 from "./msgCollect.vue?vue&type=style&index=0&id=3244b54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244b54c",
  null
  
)

export default component.exports